import type Owner from '@ember/owner';
import Route from '@ember/routing/route';
import type { Registry as Services } from '@ember/service';
import { service } from '@ember/service';
import type { Transition } from 'lumen/services/transition';
import { BudgetForecastDataFetching } from 'lumen/utils/budget-forecast/data-fetching';
import protectedRoute from 'lumen/utils/decorators/protected-route';

interface ForecastIndexModel {
  entries: typeof BudgetForecastDataFetching.prototype.fetchEntriesTask;
}

@protectedRoute({
  features: 'business_intelligence.settings.budget_and_forecast',
  redirectTo: 'hotel.settings',
})
export default class HotelSettingsForecastIndexRoute extends Route {
  @service declare navigation: Services['navigation'];

  #dataFetching: BudgetForecastDataFetching;

  constructor(owner: Owner) {
    super(owner);
    this.#dataFetching = new BudgetForecastDataFetching(owner);
  }

  beforeModel(transition: Transition): void {
    if (this.navigation.redirectToAccountSelection(transition)) {
      return;
    }
  }

  deactivate(): void {
    this.#dataFetching.cancelAll();
    this.#dataFetching.unloadAll();
  }

  model(): ForecastIndexModel {
    const model: ForecastIndexModel = {
      entries: this.#dataFetching.fetchEntriesTask,
    };

    void model.entries.perform('forecast');

    return model;
  }
}
